import { render, staticRenderFns } from "./addChannelDiag.vue?vue&type=template&id=25e64988&scoped=true&"
import script from "./addChannelDiag.vue?vue&type=script&lang=js&"
export * from "./addChannelDiag.vue?vue&type=script&lang=js&"
import style0 from "./addChannelDiag.vue?vue&type=style&index=0&id=25e64988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e64988",
  null
  
)

export default component.exports